import { object, string } from 'yup';

import { getFormValidator } from '@util/form/get-form-validator';

export const resetPasswordFormValidation = getFormValidator(
  object().shape({
    email: string().email(),
  }),
);
